'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var index = require('../adapter/index.js');
var transport = require('../transport/transport.js');

var __async = (__this, __arguments, generator) => {
  return new Promise((resolve, reject) => {
    var fulfilled = (value) => {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    };
    var rejected = (value) => {
      try {
        step(generator.throw(value));
      } catch (e) {
        reject(e);
      }
    };
    var step = (x) => x.done ? resolve(x.value) : Promise.resolve(x.value).then(fulfilled, rejected);
    step((generator = generator.apply(__this, __arguments)).next());
  });
};
class Translations {
  fetch(locale, isProd = false) {
    return __async(this, null, function* () {
      const content = yield index.adapter.translations.fetch(this.getTranslationsUrl(locale, isProd));
      return JSON.parse(content);
    });
  }
  getTranslationsUrl(locale, isProd) {
    const file = `${locale}${isProd ? "" : "-staging"}.json`;
    return `${transport.transport.getCDNUrl()}/translations/${file}`;
  }
}
const translations = new Translations();

exports.translations = translations;
